import { Layout, Streets as StreetsComponent } from "components"
export const Streets = () => {
 return (
  <Layout>
   <StreetsComponent />
  </Layout>
 )
}
